/**
 * HAWK CHECKOUT MANAGER v5.0 (Iyzico Integration)
 * - iyzico (Primary) & PayTR (Fallback)
 */

class HawkCheckoutManager {
    constructor(config) {
        this.language = config.language || 'tr';
        this.proxyUrl = 'https://api.hawkgaming.com.tr/api/proxy';
        this.proxyUploadUrl = 'https://api.hawkgaming.com.tr/api/upload-image';
        
        // Global Veriler
        this.globals = {
            tasarimismi: window.tasarimismi || ["Orijinal"],
            onlogoyuklendi: window.onlogoyuklendi || false,
            arkalogoyuklendi: window.arkalogoyuklendi || false,
            bellogoyuklendi: window.bellogoyuklendi || false,
            yastiklogoyuklendi: window.yastiklogoyuklendi || false,
            siparis_data: window.siparis_data || {},
            resultonlogo: window.resultonlogo || [],
            resultarkalogo: window.resultarkalogo || [],
            resultbellogo: window.resultbellogo || [],
            resultyastiklogo: window.resultyastiklogo || []
        };

        this.apiData = { cities: [], prices: [], invoiceTypes: [] };
        
        this.state = {
            currentStep: 'userInfo',
            isCorporate: false,
            isDiffBilling: false,
            formattedPrice: "0 ₺"
        };

        this.translations = {
            tr: {
                userInfoTitle: "Kullanıcı Bilgileri",
                summaryTitle: "Sipariş Özeti",
                paymentTitle: "Güvenli Ödeme",
                loading: "İşleniyor...",
                uploading: "Görseller Yükleniyor...",
                fillAll: "Lütfen bütün zorunlu alanları doldurunuz.",
                deliveryAddress: "Teslimat Adresi",
                billingAddress: "Fatura Adresi",
                corporateInfo: "Kurumsal Bilgiler",
                name: "İsim", surname: "Soyisim", email: "E-posta", phone: "Cep Telefonu",
                city: "İl Seçiniz", district: "İlçe Seçiniz", address: "Açık Adres",
                invoiceType: "Fatura Tipi", individual: "Bireysel", corporate: "Kurumsal",
                taxTitle: "Ticari Ünvan", taxNo: "Vergi No", taxOffice: "Vergi Dairesi",
                diffBilling: "Fatura bilgilerimi farklı girmek istiyorum.",
                warningTitle: "Dikkat",
                warningText: "Özel tasarımlı oyuncu koltuğu siparişinin iptali ve iadesi kabul edilmemektedir.",
                summaryDelivery: "Teslimat Bilgileri",
                summaryBilling: "Fatura Bilgileri",
                summaryCorporate: "Kurumsal Bilgiler",
                totalAmount: "ÖDEMENİZ GEREKEN TUTAR",
                shippingInfo: "ARAS Kargo Apartman Dış Kapı Teslim (20 iş günü içerisinde ÜCRETSİZ kargoya teslim.)",
                next: "Ödeme Bilgileri", payNow: "Ödemeyi Tamamla", back: "Geri Dön", close: "Kapat"
            }
        };

        this.init();
    }

    async init() {
        this.injectStyles();
        this.createModalStructure();
        await this.fetchAllData();
    }

    t(key) { return this.translations[this.language][key] || key; }

    // --- AÇ/KAPA İŞLEMLERİ ---
    open() {
        const priceEl = document.getElementById("toplamfiyatsayı");
        if(priceEl) {
            this.state.formattedPrice = priceEl.innerText;
            
            // Fiyatı Temizle (Backend İçin)
            let rawString = priceEl.innerText
                .replace('₺', '')
                .replace(/\./g, '')
                .replace(',', '.')
                .trim();
            let numericPrice = parseFloat(rawString);
            let finalBackendPrice = numericPrice.toFixed(0); 

            this.updateOrder(finalBackendPrice, "PaymentAmount");
        }

        this.refreshGlobals();
        document.getElementById('hawk-checkout-overlay').style.display = 'block';
        document.body.style.overflow = 'hidden';
        this.renderUserInfo();
    }

    close() {
        document.getElementById('hawk-checkout-overlay').style.display = 'none';
        document.body.style.overflow = '';
        const modal = document.getElementById('hawk-checkout-modal');
        modal.classList.remove('hawk-modal-large'); 
        document.getElementById('hawk-modal-footer').style.display = 'block';

        // Temizlik
        const inputs = document.querySelectorAll('.hawk-input');
        inputs.forEach(inp => {
            if(inp.type === 'checkbox' || inp.type === 'radio') inp.checked = false;
            else inp.value = '';
        });

        this.state.isCorporate = false;
        this.state.isDiffBilling = false;

        if (!this.orderData) {
            if (typeof window.orderData !== 'undefined') this.orderData = window.orderData;
            else this.orderData = {};
        }   

        this.orderData.Delivery = { "FirstName": "", "LastName": "", "Email": "", "Phone": "", "Address": "", "District": 0, "Province": 0, "Country": "TR" };
        this.orderData.Invoice = { "Type": 0, "Company": "", "TaxNumber": "", "TaxOffice": "", "FirstName": "", "LastName": "", "Email": "", "Phone": "", "Address": "" };
        
        // iyzico script kalıntılarını temizle (Varsa)
        const iyziForm = document.getElementById('iyzipay-checkout-form');
        if(iyziForm) iyziForm.innerHTML = '';
    }

    refreshGlobals() {
        this.globals = {
            tasarimismi: window.tasarimismi || ["Orijinal"],
            onlogoyuklendi: window.onlogoyuklendi || false,
            arkalogoyuklendi: window.arkalogoyuklendi || false,
            bellogoyuklendi: window.bellogoyuklendi || false,
            yastiklogoyuklendi: window.yastiklogoyuklendi || false,
            siparis_data: window.siparis_data || {},
            resultonlogo: window.resultonlogo || [],
            resultarkalogo: window.resultarkalogo || [],
            resultbellogo: window.resultbellogo || [],
            resultyastiklogo: window.resultyastiklogo || []
        };
    }

    // ============================================================
    // MAIN LOGIC: SİPARİŞ OLUŞTURMA & IYZICO/PAYTR YÖNETİMİ
    // ============================================================
    async initPayment() {
        const termsCheckbox = document.getElementById('chk_terms');
        const termsContainer = document.getElementById('terms-container');

        if (!termsCheckbox || !termsCheckbox.checked) {
            if(termsContainer) {
                termsContainer.style.border = "2px solid #C41414";
                termsContainer.style.backgroundColor = "#ffecec";
                termsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
                termsContainer.animate([
                    { transform: 'translateX(0)' }, { transform: 'translateX(-5px)' }, 
                    { transform: 'translateX(5px)' }, { transform: 'translateX(0)' }
                ], { duration: 300 });
            }
            alert("Lütfen Mesafeli Satış Sözleşmesi'ni onaylayınız.");
            return;
        }

        if (this.globals.tasarimismi[0] === "Orijinal" && !this.globals.bellogoyuklendi && !this.globals.arkalogoyuklendi && !this.globals.onlogoyuklendi) {
            alert("Yalnızca yastık logo veya nickname ekleyerek sipariş veremezsiniz. Lütfen başka bir logo veya desen ekleyin.");
            return; 
        }

        this.renderLoading(this.t('loading'));

        try {
            const ipData = await fetch('https://api.ipify.org?format=json').then(res => res.json()).catch(() => ({ ip: '127.0.0.1' }));
            this.updateOrder(ipData.ip, "Customer.IPNumber");

            // --- DEĞİŞİKLİK BURADA: PaymentType Parametresi Eklendi ---
            // iyzico öncelikli deniyoruz.
            window.orderData.PaymentType = "iyzico"; 

            const response = await fetch(this.proxyUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ endpoint: '/order/create', body: window.orderData })
            });

            const result = await response.json();
console.log(result)
           if (result.result === true && result.items) {
                const orderNo = result.items.OrderNo;
                
                this.renderLoading(this.t('uploading'));
                await this.uploadAllImages(orderNo);

                // --- ÖDEME YÖNLENDİRMESİ (IYZICO vs PAYTR) ---
                
                // Senaryo 1: Iyzico Responsive Form (HTML İçeriği)
                if (result.items.checkoutFormContent) {
                    console.log("iyzico Form (Responsive) Başlatılıyor...");
                    this.renderIyzicoForm(result.items.checkoutFormContent);
                } 
                
                // Senaryo 2: Iyzico Redirect/Iframe URL'i (YENİ EKLENEN KISIM)
                else if (result.items.PaymentPageUrl) {
                    console.log("iyzico Sayfası (Iframe/Redirect) Başlatılıyor...");
                    // iframe=true ekleyerek modal içinde açılmasını sağlıyoruz
                    let url = result.items.PaymentPageUrl;
                   
                    this.renderIyzicoIframe(url);
                }

                // Senaryo 3: Sadece Token var (PayTR Fallback)
                // Dikkat: iyzico da token dönebilir ama yukarıdaki kontroller (Url/Content) bunu yakalar.
                // Sadece Token varsa ve URL yoksa PayTR'dir.
                else if (result.items.Token) {
                    console.warn("iyzico özel yanıtı yok, PayTR'ye geçiliyor (Fallback)...");
                    this.renderPayTR(result.items.Token);
                }
                
                else {
                    throw new Error("Ödeme sistemi başlatılamadı (Geçerli bir ödeme verisi yok).");
                }

            } else {
                // Sentry Error Reporting
                if (window.Sentry) {
                    Sentry.withScope(scope => {
                        scope.setTag("error_source", "backend_api_response");
                        scope.setLevel("error"); 
                        scope.setContext("API Error Details", { result: result, request_body: window.orderData });
                        Sentry.captureException(new Error(`Backend Hatası: ${result.message || "Bilinmeyen Hata"}`));
                    });
                }
                throw new Error(result.message || "Sipariş oluşturulamadı.");
            }

        } catch (error) {
            console.error("Hata:", error);
            alert("Hata: " + error.message);
            this.renderPaymentSummary(); // Hatada özete dön
        }
    }

    // --- IYZICO RENDER ---
    // --- IYZICO IFRAME RENDER (URL ile) ---
    renderIyzicoIframe(url) {
        this.markStep(3);
        document.getElementById('hawk-checkout-modal').classList.add('hawk-modal-wide');
        document.getElementById('hawk-modal-title').textContent = this.t('paymentTitle');
        
        const html = `
            <div class="hawk-iframe-wrapper" style="height:100%;">
                <iframe src="${url}" 
                    id="iyzicoiframe" 
                    frameborder="0" 
                    style="width:100%; height:100%; min-height:600px;"
                    scrolling="yes">
                </iframe>
            </div>
        `;
        
        const bodyEl = document.getElementById('hawk-modal-content');
        bodyEl.innerHTML = html;
        bodyEl.style.padding = "0";
        bodyEl.style.height = "85vh !important;";
        console.log("hello")
        document.getElementById('hawk-modal-footer').style.display = 'none';
    }

    // --- PAYTR RENDER (ESKİ YAPI - YEDEK) ---
    renderPayTR(token) {
        this.markStep(3);
        document.getElementById('hawk-checkout-modal').classList.add('hawk-modal-wide');
        document.getElementById('hawk-modal-title').textContent = this.t('paymentTitle');
        
        const html = `
            <div class="hawk-iframe-wrapper" style="height:100%;">
                <iframe src="https://www.paytr.com/odeme/guvenli/${token}" 
                    id="paytriframe" 
                    frameborder="0" 
                    scrolling="yes">
                </iframe>
            </div>
            <script>if(typeof iFrameResize === 'function') iFrameResize({},'#paytriframe');</script>
        `;
        
        const bodyEl = document.getElementById('hawk-modal-content');
        bodyEl.innerHTML = html;
        bodyEl.style.padding = "0";
        document.getElementById('hawk-modal-footer').style.display = 'none';
        
        if(!window.iFrameResize) {
            const script = document.createElement('script');
            script.src = "https://www.paytr.com/js/iframeResizer.min.js";
            document.body.appendChild(script);
        }
    }

    // --- RESİM YÜKLEME ---
    async uploadAllImages(orderNo) {
        const g = this.globals;
        if(g.siparis_data.onresim && g.siparis_data.onresim[0]) await this.sendPhoto(orderNo, "ProductPhoto1", g.siparis_data.onresim[0]);
        if(g.siparis_data.arkaresim && g.siparis_data.arkaresim[0]) await this.sendPhoto(orderNo, "ProductPhoto2", g.siparis_data.arkaresim[0]);
        if(g.onlogoyuklendi && g.resultonlogo[0]) await this.sendPhoto(orderNo, "FrontLogo", g.resultonlogo[0]);
        if(g.arkalogoyuklendi && g.resultarkalogo[0]) await this.sendPhoto(orderNo, "BackLogo", g.resultarkalogo[0]);
        if(g.bellogoyuklendi && g.resultbellogo[0]) await this.sendPhoto(orderNo, "WaistLogo", g.resultbellogo[0]);
        if(g.yastiklogoyuklendi && g.resultyastiklogo[0]) await this.sendPhoto(orderNo, "Nickname", g.resultyastiklogo[0]);
    }

    async sendPhoto(OrderNo, type, imageData) {
        const formdata = new FormData();
        let blob, filename;

        if (imageData instanceof Blob) {
            blob = imageData;
            const ext = blob.type === "image/png" ? "png" : "webp";
            filename = `image.${ext}`;
        } else if (typeof imageData === "string" && imageData.startsWith("data:image/")) {
            const mimeMatch = imageData.match(/^data:(image\/(png|webp));base64,/);
            if (!mimeMatch) return;
            const mimeType = mimeMatch[1];
            const extension = mimeMatch[2];
            const base64 = imageData.replace(/^data:image\/(png|webp);base64,/, "");
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) { byteNumbers[i] = byteCharacters.charCodeAt(i); }
            const byteArray = new Uint8Array(byteNumbers);
            blob = new Blob([byteArray], { type: mimeType });
            filename = `image.${extension}`;
        } else return;

        formdata.append(type, blob, filename);

        try {
            await fetch(`${this.proxyUploadUrl}?OrderNo=${OrderNo}&type=${type}`, {
                method: "POST",
                body: formdata
            });
        } catch (error) {
            console.error(`${type} upload failed:`, error);
        }
    }

    // --- UI HELPER ---
    renderLoading(msg) {
        const html = `
            <div style="display:flex; flex-direction:column; align-items:center; justify-content:center; height:300px;">
                <img src="/static/image/loading3.gif" style="width:60px; height:60px;">
                <p style="margin-top:20px; font-weight:600; color:#333;">${msg}</p>
            </div>
        `;
        document.getElementById('hawk-modal-content').innerHTML = html;
        document.getElementById('hawk-modal-footer').innerHTML = '';
    }

    renderUserInfo() {
        document.getElementById('hawk-modal-footer').style.display = 'block';
        this.state.currentStep = 'userInfo';
        this.markStep(1);
        document.getElementById('hawk-checkout-modal').classList.remove('hawk-modal-wide');
        document.getElementById('hawk-modal-title').textContent = this.t('userInfoTitle');

        const html = `
            <div class="hawk-form-section">
                <div id="hawk-error-msg" class="hawk-error-box">${this.t('fillAll')}</div>
                <h4 class="hawk-section-title">${this.t('deliveryAddress')}</h4>
                <div class="hawk-grid-2">
                    <input type="text" id="chk_name" class="hawk-input required" placeholder="${this.t('name')}" oninput="checkoutManager.updateOrder(this.value, 'Delivery.FirstName'); checkoutManager.updateOrder(this.value, 'Customer.FirstName')">
                    <input type="text" id="chk_surname" class="hawk-input required" placeholder="${this.t('surname')}" oninput="checkoutManager.updateOrder(this.value, 'Delivery.LastName'); checkoutManager.updateOrder(this.value, 'Customer.LastName')">
                </div>
                <div class="hawk-grid-2">
                    <input type="email" id="chk_email" class="hawk-input required" placeholder="${this.t('email')}" oninput="checkoutManager.updateOrder(this.value, 'Delivery.Email'); checkoutManager.updateOrder(this.value, 'Customer.Email')">
                    <input type="tel" id="chk_phone" class="hawk-input required" placeholder="${this.t('phone')}" maxlength="14" oninput="checkoutManager.updateOrder(this.value, 'Delivery.Phone'); checkoutManager.updateOrder(this.value, 'Customer.Phone')">
                </div>
                <div class="hawk-grid-2">
                    <select id="chk_city" class="hawk-input required"><option value="">${this.t('city')}</option></select>
                    <select id="chk_district" class="hawk-input required" disabled><option value="">${this.t('district')}</option></select>
                </div>
                <textarea id="chk_address" class="hawk-input required" rows="2" placeholder="${this.t('address')}" oninput="checkoutManager.updateOrder(this.value, 'Delivery.Address')"></textarea>
                
                <hr class="hawk-divider">
                
                <div style="margin-bottom:15px;">
                    <label class="hawk-label-title">${this.t('invoiceType')}</label>
                    <div style="display:flex; gap:20px;">
                        <label class="hawk-label-group"><input type="radio" class="hawk-radio" name="invoice_type" value="individual" checked onchange="checkoutManager.toggleCorporate(false)"><span>${this.t('individual')}</span></label>
                        <label class="hawk-label-group"><input type="radio" class="hawk-radio" name="invoice_type" value="corporate" onchange="checkoutManager.toggleCorporate(true)"><span>${this.t('corporate')}</span></label>
                    </div>
                </div>
                
                <div id="hawk-corporate-fields" style="display:none; background:rgba(0,0,0,0.03); padding:15px; border-radius:12px; margin-bottom:15px;">
                    <h5 style="margin-top:0; margin-bottom:10px;">${this.t('corporateInfo')}</h5>
                    <input type="text" id="chk_tax_title" class="hawk-input" placeholder="${this.t('taxTitle')}" oninput="checkoutManager.updateOrder(this.value, 'Invoice.Company')">
                    <div class="hawk-grid-2">
                        <input type="text" id="chk_tax_no" class="hawk-input" placeholder="${this.t('taxNo')}" oninput="checkoutManager.updateOrder(this.value, 'Invoice.TaxNumber')">
                        <input type="text" id="chk_tax_office" class="hawk-input" placeholder="${this.t('taxOffice')}" oninput="checkoutManager.updateOrder(this.value, 'Invoice.TaxOffice')">
                    </div>
                </div>
                
                <div style="margin-bottom:15px;">
                    <label class="hawk-label-group"><input type="checkbox" id="chk_diff_billing" class="hawk-radio" onchange="checkoutManager.toggleBillingAddress(this.checked)"><span>${this.t('diffBilling')}</span></label>
                </div>
                
                <div id="hawk-billing-fields" style="display:none; margin-top:15px;">
                    <h4 class="hawk-section-title">${this.t('billingAddress')}</h4>
                    <div class="hawk-grid-2">
                        <input type="text" id="chk_bill_name" class="hawk-input" placeholder="${this.t('name')}" oninput="checkoutManager.updateOrder(this.value, 'Invoice.FirstName')">
                        <input type="text" id="chk_bill_surname" class="hawk-input" placeholder="${this.t('surname')}" oninput="checkoutManager.updateOrder(this.value, 'Invoice.LastName')">
                    </div>
                    <div class="hawk-grid-2">
                        <input type="email" id="chk_bill_email" class="hawk-input" placeholder="${this.t('email')}" oninput="checkoutManager.updateOrder(this.value, 'Invoice.Email')">
                        <input type="tel" id="chk_bill_phone" class="hawk-input" placeholder="${this.t('phone')}" oninput="checkoutManager.updateOrder(this.value, 'Invoice.Phone')">
                    </div>
                    <div class="hawk-grid-2">
                        <select id="chk_bill_city" class="hawk-input"><option value="">${this.t('city')}</option></select>
                        <select id="chk_bill_district" class="hawk-input" disabled><option value="">${this.t('district')}</option></select>
                    </div>
                    <textarea id="chk_bill_address" class="hawk-input" rows="2" placeholder="${this.t('address')}" oninput="checkoutManager.updateOrder(this.value, 'Invoice.Address')"></textarea>
                </div>
            </div>
        `;
        document.getElementById('hawk-modal-content').innerHTML = html;
        document.getElementById('hawk-modal-footer').innerHTML = `<button class="hawk-btn-primary" onclick="checkoutManager.processPart1()">${this.t('next')}</button>`;
        this.bindCitySelects();
        this.restoreInputs();
    }

    renderPaymentSummary() {
        this.state.currentStep = 'summary';
        this.markStep(2);
        document.getElementById('hawk-checkout-modal').classList.add('hawk-modal-wide');
        document.getElementById('hawk-modal-title').textContent = this.t('summaryTitle');

        const del = window.orderData.Delivery;
        const inv = window.orderData.Invoice;
        const img1 = this.state.previewImage1 || "/static/image/koltuk1.png";
        const img2 = this.state.previewImage2 || "/static/image/koltuk2.png";

        const html = `
            <div class="hawk-form-section">
                <div style="background:#fff9e6; border:1px solid #ffecb3; padding:12px 15px; border-radius:12px; margin-bottom:20px; font-size:13px; color:#8a6d3b; display:flex; align-items:center; gap:10px;">
                    <span style="font-size:20px;">⚠️</span>
                    <div>${this.t('warningText')}</div>
                </div>
                <div class="hawk-images-container">
                    <div class="hawk-img-box">
                        <img src="${img1}" alt="Ön Görünüm">
                        <div class="hawk-img-label">Ön Görünüm</div>
                    </div>
                    <div class="hawk-img-box">
                        <img src="${img2}" alt="Arka Görünüm">
                        <div class="hawk-img-label">Arka Görünüm</div>
                    </div>
                </div>
                <div class="hawk-details-grid">
                    <div class="hawk-summary-card">
                        <h5 style="display:flex; justify-content:space-between; align-items:center;">
                            ${this.t('summaryDelivery')} 
                            <button onclick="checkoutManager.renderUserInfo()" style="background:#f0f0f0; border:none; padding:4px 8px; border-radius:6px; cursor:pointer; color:#333; font-size:12px;">Düzenle</button>
                        </h5>
                        <div class="hawk-summary-row"><span>Alıcı</span> <strong>${del.FirstName} ${del.LastName}</strong></div>
                        <div class="hawk-summary-row"><span>Telefon</span> ${del.Phone}</div>
                        <div class="hawk-summary-row"><span>E-posta</span> ${del.Email}</div>
                        <div class="hawk-summary-row"><span>İl/İlçe</span> ${this.state.selectedDistrictName} / ${this.state.selectedCityName}</div>
                        <div style="margin-top:8px; font-size:13px; color:#555; line-height:1.4; background:#f9f9f9; padding:8px; border-radius:6px;">
                            ${del.Address}
                        </div>
                    </div>
                    <div style="display:flex; flex-direction:column; gap:15px;">
                        <div class="hawk-summary-card" style="flex:1;">
                            <h5>${this.t('summaryBilling')}</h5>
                            ${this.state.isCorporate ? `
                                <div class="hawk-summary-row"><span>Firma</span> <strong>${inv.Company}</strong></div>
                                <div class="hawk-summary-row"><span>Vergi</span> ${inv.TaxOffice} / ${inv.TaxNumber}</div>
                            ` : `
                                <div class="hawk-summary-row"><span>Kişi</span> <strong>${inv.FirstName} ${inv.LastName}</strong></div>
                            `}
                            <div class="hawk-summary-row"><span>Adres</span> <span style="text-align:right; max-width:60%;">${inv.Address.substring(0,30)}...</span></div>
                        </div>
                        <div style="background:var(--hawk-red); color:#fff; padding:20px; border-radius:12px; text-align:center; box-shadow:0 10px 20px rgba(196, 20, 20, 0.2);">
                            <div style="font-size:12px; font-weight:700; letter-spacing:0.06em; opacity:0.95; margin-bottom:6px;">${this.t('totalAmount')}</div>
                            <div style="font-size:32px; font-weight:800; letter-spacing:-1px;">${this.state.formattedPrice}</div>
                        </div>
                    </div>
                </div>
                <hr class="hawk-divider">
                <div id="terms-container" style="background:#f4f4f4; padding:15px; border-radius:12px; transition:0.3s;">
                    <label style="display:flex; align-items:flex-start; cursor:pointer; font-size:13px; line-height:1.5; color:#555;">
                        <input type="checkbox" id="chk_terms" style="margin-right:12px; margin-top:2px; width:20px; height:20px; accent-color:#C41414;">
                        <span>
                            <a href="javascript:void(0)" onclick="checkoutManager.renderContract('preliminary')" style="color:#C41414; text-decoration:underline; font-weight:600;">Ön Bilgilendirme Formu</a> ve 
                            <a href="javascript:void(0)" onclick="checkoutManager.renderContract('sales')" style="color:#C41414; text-decoration:underline; font-weight:600;">Mesafeli Satış Sözleşmesi</a>'ni okudum, onaylıyorum.
                        </span>
                    </label>
                </div>
            </div>
        `;
        document.getElementById('hawk-modal-content').innerHTML = html;
        document.getElementById('hawk-modal-footer').innerHTML = `
            <div class="hawk-cargo-info">
                <img src="/static/image/araskargo.png" style="height:24px;">
                <span>${this.t('shippingInfo')}</span>
            </div>
            <div style="display:flex; gap:15px; margin-top:15px;">
                <button class="hawk-btn-secondary" onclick="checkoutManager.renderUserInfo()" style="flex:1;">${this.t('back')}</button>
                <button class="hawk-btn-primary" onclick="checkoutManager.initPayment()" style="flex:2; font-size:18px;">${this.t('payNow')} &rarr;</button>
            </div>
        `;
    }

    renderContract(type) {
        const title = type === 'preliminary' ? "Ön Bilgilendirme Formu" : "Mesafeli Satış Sözleşmesi";
        document.getElementById('hawk-modal-title').textContent = title;
        const contractHTML = type === 'preliminary' ? this.getPreliminaryHTML() : this.getDistanceSalesHTML();
        document.getElementById('hawk-modal-content').innerHTML = `<div class="hawk-contract-container" style="font-size:12px; line-height:1.6; color:#333;">${contractHTML}</div>`;
        document.getElementById('hawk-modal-footer').innerHTML = `<button class="hawk-btn-secondary" onclick="checkoutManager.renderPaymentSummary()" style="width:100%;">Okudum, Geri Dön</button>`;
        document.getElementById('hawk-modal-content').scrollTop = 0; 
    }

    // --- VALIDASYON & FOTOĞRAF ÇEKİMİ ---
    async processPart1() {
        const requiredInputs = document.querySelectorAll('.hawk-input.required');
        let isValid = true;
        let firstError = null;
        document.getElementById('hawk-error-msg').style.display = 'none';
        requiredInputs.forEach(inp => {
            inp.style.borderColor = '#e0e0e0';
            if (inp.offsetParent === null) return; 
            if (!inp.value.trim()) {
                isValid = false;
                inp.style.borderColor = '#C41414';
                if (!firstError) firstError = inp;
            }
        });
        if (!isValid) {
            document.getElementById('hawk-error-msg').style.display = 'block';
            document.getElementById('hawk-checkout-modal').scrollTop = 0;
            if(firstError) firstError.focus();
            return;
        }
        this.syncInvoiceData();
        this.renderLoading("Koltuk tasarımınızın görselleri hazırlanıyor...");
        try {
            await this.captureModelImages();
            this.renderPaymentSummary();
        } catch (error) {
            console.error("Fotoğraf çekme hatası:", error);
            alert("Görseller oluşturulurken bir hata oluştu, varsayılan görsellerle devam ediliyor.");
            this.renderPaymentSummary(); 
        }
    }

    async captureModelImages() {
        const modelViewer = document.getElementById("hawkgamingchair");
        const isAksesuar = window.cinsbutton && window.cinsbutton.includes("aksesuar");
        const sleep = (ms) => new Promise(r => setTimeout(r, ms));

        if (isAksesuar) {
            modelViewer.cameraOrbit = "-10.67deg 75deg 1.303m";
            modelViewer.fieldOfView = "30deg";
            modelViewer.cameraTarget = "-0.01m 0.14m 0.01m";
        } else {
            modelViewer.cameraOrbit = "1.143deg 75.76deg 2.777m";
            modelViewer.fieldOfView = "22.31deg";
            modelViewer.cameraTarget = "-0.01m 0.85m -0.13m";
        }
        await sleep(600);
        const img1Base64 = modelViewer.toDataURL("image/webp", 0.4);
        if(window.hawkUtils) {
            const blob1 = await window.hawkUtils.resizeImageToBlobWithAspectRatio(img1Base64, 800, 900);
            window.siparis_data.onresim = [blob1];
        }
        this.state.previewImage1 = img1Base64;

        if (isAksesuar) {
            modelViewer.cameraOrbit = "170deg 75.97deg 1.356m";
            modelViewer.fieldOfView = "30deg";
            modelViewer.cameraTarget = "-0.01m 0.14m 0.01m";
        } else {
            modelViewer.cameraOrbit = "180deg 84.14deg 2.665m";
            modelViewer.fieldOfView = "21deg";
            modelViewer.cameraTarget = "0m 0.92m -0.23m";
        }
        await sleep(600);
        const img2Base64 = modelViewer.toDataURL("image/webp", 0.4);
        if(window.hawkUtils) {
            const blob2 = await window.hawkUtils.resizeImageToBlobWithAspectRatio(img2Base64, 800, 900);
            window.siparis_data.arkaresim = [blob2];
        }
        this.state.previewImage2 = img2Base64;
    }

    // --- DATA HELPERS ---
    syncInvoiceData() {
        let bireyselID = 0, kurumsalID = 0;
        if (this.apiData.invoiceTypes.length > 0) {
            const bir = this.apiData.invoiceTypes.find(i => i.Title.includes('Bireysel'));
            const kur = this.apiData.invoiceTypes.find(i => i.Title.includes('Kurumsal'));
            if(bir) bireyselID = bir.id;
            if(kur) kurumsalID = kur.id;
        }
        if (this.state.isCorporate) {
            this.updateOrder(kurumsalID, "Invoice.Type");
            if (!this.state.isDiffBilling) this.copyDeliveryToInvoice();
        } else {
            this.updateOrder(bireyselID, "Invoice.Type");
            this.updateOrder("", "Invoice.Company");
            this.updateOrder("", "Invoice.TaxNumber");
            this.updateOrder("", "Invoice.TaxOffice");
            if (!this.state.isDiffBilling) this.copyDeliveryToInvoice();
        }
    }

    copyDeliveryToInvoice() {
        const d = window.orderData.Delivery; 
        this.updateOrder(d.FirstName, "Invoice.FirstName");
        this.updateOrder(d.LastName, "Invoice.LastName");
        this.updateOrder(d.Email, "Invoice.Email");
        this.updateOrder(d.Phone, "Invoice.Phone");
        this.updateOrder(d.Address, "Invoice.Address");
    }

    updateOrder(value, path) {
        if (path.includes('Phone')) value = value.replace(/\D/g, '').slice(-10);
        if (typeof window.updateOrderJson === 'function') window.updateOrderJson(value, path);
    }

    async fetchAllData() {
        try {
            const citiesReq = await this.fetchProxy({ CatID: 1, RowCount: 81 });
            this.apiData.cities = citiesReq.items || [];
            const pricesReq = await this.fetchProxy({ CatID: 8, RowCount: 50 });
            this.apiData.prices = pricesReq.items || [];
            window.customfiyatlar = this.apiData.prices; 
            const invoiceReq = await this.fetchProxy({ CatID: 3, RowCount: 5 });
            this.apiData.invoiceTypes = invoiceReq.items || [];
            if(this.apiData.invoiceTypes.length > 0) {
                this.apiData.invoiceTypes.forEach(item => {
                    if (item.Title === 'Bireysel Fatura') window.bireysel = item.id;
                    if (item.Title === 'Kurumsal Fatura') window.kurumsal = item.id;
                });
            }
            const bireyselTip = this.apiData.invoiceTypes.find(i => i.Title.includes("Bireysel"));
            if(bireyselTip) this.updateOrder(bireyselTip.id, "Invoice.Type");
        } catch (error) { console.error("API Veri Çekme Hatası:", error); }
    }

    async fetchProxy(bodyData) {
        const response = await fetch(this.proxyUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                endpoint: '/common/definedetails',
                body: { id: 0, Sorting: "", CurrentPage: 1, ...bodyData }
            })
        });
        return await response.json();
    }

    bindCitySelects() {
        const citySelects = ['chk_city', 'chk_bill_city'];
        citySelects.forEach(selectId => {
            const select = document.getElementById(selectId);
            if(!select) return;
            this.apiData.cities.forEach(city => {
                const option = document.createElement('option');
                option.value = city.id; option.text = city.Title;
                option.dataset.features = JSON.stringify(city.Features);
                select.appendChild(option);
            });
            select.addEventListener('change', (e) => {
                const selectedOption = e.target.options[e.target.selectedIndex];
                const features = JSON.parse(selectedOption.dataset.features || '[]');
                if(selectId === 'chk_city') {
                    this.state.selectedCityName = selectedOption.text;
                    this.updateOrder(parseInt(e.target.value), 'Delivery.Province');
                } else {
                    this.updateOrder(parseInt(e.target.value), 'Invoice.Province');
                }
                const distId = selectId.replace('city', 'district');
                const distSelect = document.getElementById(distId);
                distSelect.innerHTML = `<option value="">${this.t('district')}</option>`;
                if (features.length > 0) {
                    distSelect.disabled = false;
                    features.forEach(feat => {
                        const opt = document.createElement('option');
                        opt.value = feat.id; opt.text = feat.Title;
                        distSelect.appendChild(opt);
                    });
                } else { distSelect.disabled = true; }
            });
            const distId = selectId.replace('city', 'district');
            const distSelect = document.getElementById(distId);
            if(distSelect) {
                distSelect.addEventListener('change', (e) => {
                    if(selectId === 'chk_city') {
                        this.state.selectedDistrictName = e.target.options[e.target.selectedIndex].text;
                        this.updateOrder(parseInt(e.target.value), 'Delivery.District');
                    }
                });
            }
        });
    }

    toggleCorporate(isCorp) {
        this.state.isCorporate = isCorp;
        const div = document.getElementById('hawk-corporate-fields');
        const inputs = div.querySelectorAll('input');
        div.style.display = isCorp ? 'block' : 'none';
        inputs.forEach(i => isCorp ? i.classList.add('required') : i.classList.remove('required'));
    }

    toggleBillingAddress(isDiff) {
        this.state.isDiffBilling = isDiff;
        const div = document.getElementById('hawk-billing-fields');
        const inputs = div.querySelectorAll('.hawk-input');
        div.style.display = isDiff ? 'block' : 'none';
        inputs.forEach(i => isDiff ? i.classList.add('required') : i.classList.remove('required'));
    }

    restoreInputs() {
        const d = window.orderData.Delivery;
        const i = window.orderData.Invoice;
        const setVal = (id, val) => { if(document.getElementById(id) && val) document.getElementById(id).value = val; };
        
        setVal('chk_name', d.FirstName); setVal('chk_surname', d.LastName); setVal('chk_email', d.Email); setVal('chk_phone', d.Phone); setVal('chk_address', d.Address);
        setVal('chk_tax_title', i.Company); setVal('chk_tax_no', i.TaxNumber); setVal('chk_tax_office', i.TaxOffice);

        if(this.state.isCorporate) {
            const rad = document.querySelector('input[name="invoice_type"][value="corporate"]');
            if(rad) { rad.checked = true; this.toggleCorporate(true); }
        }
        if(this.state.isDiffBilling) {
            const chk = document.getElementById('chk_diff_billing');
            if(chk) { chk.checked = true; this.toggleBillingAddress(true); }
        }
    }

    // --- SÖZLEŞME METİNLERİ ---
    getPreliminaryHTML() {
        const d = window.orderData;
        const inv = d.Invoice;
        const date = new Date().toLocaleDateString('tr-TR');
        const buyerName = inv.Type === 1 ? inv.Company : `${inv.FirstName} ${inv.LastName}`;
        return `<h3 style="text-align:center; margin-bottom:15px;">ÖN BİLGİLENDİRME FORMU</h3>
            <p><strong>1. SATICI BİLGİLERİ</strong><br>Ünvanı: Şahin Büro Mobilyaları Ltd. Şti.<br>Adres: Orta Mah. Nar Sokak. No:17 Bayrampaşa / İSTANBUL<br>Telefon: 0 850 302 80 77<br>E-posta: info@hawkchair.com</p>
            <p><strong>2. ALICI BİLGİLERİ</strong><br>Adı/Soyadı/Ünvanı: ${buyerName}<br>Adresi: ${inv.Address}<br>Telefon: ${inv.Phone}<br>E-posta: ${inv.Email}</p>
            <p><strong>3. SÖZLEŞME KONUSU ÜRÜN BİLGİLERİ</strong><br>Tarih: ${date}<br>Ürün Adı: Hawk Gaming Chair Özel Tasarım Oyuncu Koltuğu<br>Adet: 1<br><strong>Toplam Tutar (KDV Dahil): ${this.state.formattedPrice}</strong></p>
            <p><strong>4. GENEL HÜKÜMLER</strong><br>4.1. ALICI, SATICI’ya ait internet sitesinde sözleşme konusu ürünün temel nitelikleri, satış fiyatı ve ödeme şekli ile teslimata ilişkin ön bilgileri okuyup, bilgi sahibi olduğunu, elektronik ortamda gerekli teyidi verdiğini kabul, beyan ve taahhüt eder.<br>4.2. Sözleşme konusu her bir ürün, 30 günlük yasal süreyi aşmamak kaydı ile ALICI' nın yerleşim yeri uzaklığına bağlı olarak internet sitesindeki ön bilgiler kısmında belirtilen süre zarfında ALICI veya ALICI’ nın gösterdiği adresteki kişi ve/veya kuruluşa teslim edilir.<br>4.3. Özel tasarım (Custom) ürünlerde iade ve değişim hakkı bulunmamaktadır.</p>
            <p><strong>5. CAYMA HAKKI</strong><br>ALICI; mal satışına ilişkin mesafeli sözleşmelerde, ürünün kendisine veya gösterdiği adresteki kişi/kuruluşa teslim tarihinden itibaren 14 (on dört) gün içerisinde cayma hakkını kullanabilir. ANCAK, tüketicinin istekleri veya kişisel ihtiyaçları doğrultusunda hazırlanan mallara ilişkin sözleşmelerde (Özel Tasarım Koltuklar) cayma hakkı kullanılamaz.</p>`;
    }

    getDistanceSalesHTML() {
        const d = window.orderData;
        const inv = d.Invoice;
        const del = d.Delivery;
        const date = new Date().toLocaleDateString('tr-TR');
        const buyerName = inv.Type === 1 ? inv.Company : `${inv.FirstName} ${inv.LastName}`;
        return `<h3 style="text-align:center; margin-bottom:15px;">MESAFELİ SATIŞ SÖZLEŞMESİ</h3>
            <p><strong>MADDE 1 - TARAFLAR</strong></p><p><strong>1.1. SATICI</strong><br>Ünvanı: Şahin Büro Mobilyaları Ltd. Şti.<br>Adresi: Orta Mah. Nar Sokak. No:17 Bayrampaşa / İSTANBUL<br>Telefon: 0 850 302 80 77</p>
            <p><strong>1.2. ALICI</strong><br>Adı/Soyadı/Ünvanı: ${buyerName}<br>Adresi: ${inv.Address}<br>Telefon: ${inv.Phone}<br>E-posta: ${inv.Email}</p>
            <p><strong>MADDE 2 - KONU</strong><br>İşbu sözleşmenin konusu, ALICI'nın SATICI'ya ait internet sitesinden elektronik ortamda siparişini yaptığı aşağıda nitelikleri ve satış fiyatı belirtilen ürünün satışı ve teslimi ile ilgili olarak 6502 sayılı Tüketicilerin Korunması Hakkındaki Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümleri gereğince tarafların hak ve yükümlülüklerinin saptanmasıdır.</p>
            <p><strong>MADDE 3 - SÖZLEŞME KONUSU ÜRÜN</strong><br>Tarih: ${date}<br>Ürün Türü: Oyuncu Koltuğu (Özel Tasarım)<br>Teslim Edilecek Kişi: ${del.FirstName} ${del.LastName}<br>Teslimat Adresi: ${del.Address}<br><strong>Ödeme Tutarı: ${this.state.formattedPrice}</strong></p>
            <p><strong>MADDE 4 - GENEL HÜKÜMLER</strong><br>4.1. ALICI, internet sitesinde sözleşme konusu ürünün temel nitelikleri, satış fiyatı ve ödeme şekli ile teslimata ilişkin ön bilgileri okuyup bilgi sahibi olduğunu ve elektronik ortamda gerekli teyidi verdiğini beyan eder.<br>4.2. Sözleşme konusu ürün, yasal 30 günlük süreyi aşmamak koşulu ile her bir ürün için ALICI'nın yerleşim yerinin uzaklığına bağlı olarak teslim edilir.</p>
            <p><strong>MADDE 5 - CAYMA HAKKI VE İSTİSNALARI</strong><br>Yönetmelik gereği, "Tüketicinin istekleri veya kişisel ihtiyaçları doğrultusunda hazırlanan mallara ilişkin sözleşmeler" cayma hakkı kapsamı dışındadır. İşbu sözleşme konusu ürün ALICI'nın seçtiği renk, logo ve isim işlemeleri ile kişiselleştirildiğinden, üretim hatası dışında keyfi iade veya değişim talep edilemez.</p>
            <p><strong>MADDE 6 - YETKİLİ MAHKEME</strong><br>İşbu sözleşmenin uygulanmasında, Tüketici Hakem Heyetleri ile ALICI'nın veya SATICI'nın yerleşim yerindeki Tüketici Mahkemeleri yetkilidir.</p>
            <p><strong>Siparişin onaylanması durumunda ALICI işbu sözleşmenin tüm koşullarını kabul etmiş sayılır.</strong></p>`;
    }

    injectStyles() {
        const styleId = 'hawk-checkout-styles';
        if (document.getElementById(styleId)) return;
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
            #hawk-checkout-overlay { display: none; position: fixed !important; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.7); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); z-index: 999998 !important; }
            #hawk-checkout-modal { position: fixed !important; top: 50% !important; left: 50% !important; transform: translate(-50%, -50%) !important; width: 100% !important; max-width: 620px !important; max-height: 85vh !important; background: rgba(255, 255, 255, 0.98) !important; border-radius: 24px !important; box-shadow: 0 25px 80px rgba(0, 0, 0, 0.6) !important; border: 1px solid rgba(255, 255, 255, 0.5) !important; display: flex !important; flex-direction: column !important; z-index: 999999 !important; font-family: 'Poppins', sans-serif !important; color: #333 !important; transition: all 0.3s ease !important; }
            #hawk-checkout-modal.hawk-modal-large { width: 95% !important; max-width: 1000px !important; height: 90vh !important; max-height: 900px !important; }
            .hawk-modal-header { flex: 0 0 auto !important; padding: 15px 25px !important; border-bottom: 1px solid rgba(0,0,0,0.05) !important; display: flex !important; justify-content: space-between !important; align-items: center !important; background: white !important; border-radius: 24px 24px 0 0 !important; z-index: 10000 !important; position: relative !important; }
            .hawk-close-btn { background: transparent !important; border: none !important; font-size: 32px !important; line-height: 1 !important; cursor: pointer !important; color: #333 !important; padding: 0 10px !important; transition: color 0.2s !important; z-index: 10001 !important; pointer-events: auto !important; position: relative !important; }
            .hawk-close-btn:hover { color: #C41414 !important; transform: rotate(90deg) !important; }
            .hawk-modal-body { flex: 1 1 auto !important; padding: 25px 30px !important; overflow-y: auto !important; overflow-x: hidden !important; position: relative !important;height:85vh; }
            .hawk-iframe-wrapper { width: 100% !important; height: 100% !important; display: block !important; overflow: hidden !important; background: #fff !important; position: relative !important; }
            iframe#paytriframe, #paytriframe, .hawk-iframe-wrapper iframe { width: 100% !important; height: 100% !important; border: none !important; display: block !important; position: absolute !important; top: 0 !important; left: 0 !important; margin: 0 !important; padding: 0 !important; min-height: 0 !important; }
            .hawk-modal-footer { flex: 0 0 auto !important; padding: 20px 30px !important; border-top: 1px solid rgba(0,0,0,0.05) !important; background: white !important; border-radius: 0 0 24px 24px !important; }
            .hawk-images-container { display: grid !important; grid-template-columns: 1fr 1fr !important; gap: 20px !important; margin-bottom: 25px !important; }
            .hawk-img-box { background: #f8f8f8 !important; border: 1px solid #eee !important; border-radius: 16px !important; height: 180px !important; display: flex !important; align-items: center !important; justify-content: center !important; overflow: hidden !important; position: relative !important; }
            .hawk-img-box img { max-height: 90% !important; max-width: 90% !important; object-fit: contain !important; }
            .hawk-img-label { position: absolute; bottom: 0px; left: 0; width: 100%; text-align: center; font-size: 12px; color: #999; font-weight: 600; text-transform: uppercase; letter-spacing: 1px;background-color: white; }
            .hawk-details-grid { display: grid !important; grid-template-columns: 1fr 1fr !important; gap: 20px !important; margin-bottom: 20px !important; }
            .hawk-cargo-info { display: flex; align-items: center; gap: 15px; background: #f9fbfd; border: 1px solid #e1e8ed; padding: 12px 15px; border-radius: 12px; margin-top: 0; font-size: 13px; color: #555; line-height: 1.4; }
            .hawk-input { width: 100% !important; background: #f4f4f4 !important; border: 1px solid #e0e0e0 !important; padding: 14px 15px !important; border-radius: 12px !important; margin-bottom: 12px !important; box-sizing: border-box !important; font-family: 'Poppins', sans-serif !important; font-size: 14px !important; color: #333 !important; outline: none !important; transition:0.3s; }
            .hawk-input:focus { background: white !important; border-color: #C41414 !important; box-shadow: 0 0 0 4px rgba(196, 20, 20, 0.1) !important; }
            .hawk-btn-primary { width: 100% !important; background: #C41414 !important; color: white !important; padding: 16px !important; border-radius: 16px !important; font-weight: 600 !important; border: none !important; cursor: pointer !important; transition: transform 0.2s !important; font-size: 16px !important; text-align: center !important; }
            .hawk-btn-primary:hover { transform: scale(1.02) !important; background: #a81010 !important; }
            .hawk-btn-secondary { background: #eee !important; color: #333 !important; padding: 16px !important; border-radius: 16px !important; font-weight: 600 !important; border: none !important; cursor: pointer !important; width:100% !important; text-align: center !important;}
            .hawk-summary-card { background: white; border: 1px solid #eee; border-radius: 12px; padding: 15px; height: 100%; }
            .hawk-summary-card h5 { margin: 0 0 10px 0; color: #C41414; font-size: 14px; text-transform: uppercase; letter-spacing: 0.5px; border-bottom: 1px solid #f0f0f0; padding-bottom: 8px; }
            .hawk-summary-row { display: flex; justify-content: space-between; margin-bottom: 6px; font-size: 13px; color: #555; }
            .hawk-label-group { display: flex !important; align-items: center !important; cursor: pointer !important; font-size: 14px !important; }
            .hawk-radio { margin-right: 8px !important; accent-color: #C41414 !important; transform: scale(1.2) !important; }
            .hawk-grid-2 { display: grid !important; grid-template-columns: 1fr 1fr !important; gap: 12px !important; }
            .hawk-section-title { margin-top:0; margin-bottom: 15px; font-size:16px; border-left: 3px solid #C41414; padding-left: 10px; color:#C41414; }
            @media (max-width: 768px) { 
                .hawk-images-container, .hawk-details-grid { grid-template-columns: 1fr !important; } 
                .hawk-img-box { height: 200px !important; }
                #hawk-checkout-modal.hawk-modal-large { width: 100% !important; height: 100% !important; max-height: 100% !important; border-radius: 0 !important; }
            }
            body.dark-mode #hawk-checkout-modal { background: rgba(25, 25, 25, 0.95) !important; color: white !important; border-color: #444 !important; }
            body.dark-mode .hawk-modal-header, body.dark-mode .hawk-modal-footer { background: rgba(25, 25, 25, 0.98) !important; border-color: rgba(255,255,255,0.1) !important; }
            body.dark-mode .hawk-iframe-wrapper, body.dark-mode #paytriframe { background: #fff !important; }
        `;
        document.head.appendChild(style);
    }
    
    createModalStructure() {
        if (document.getElementById('hawk-checkout-overlay')) return;
        const overlay = document.createElement('div');
        overlay.id = 'hawk-checkout-overlay';
        overlay.innerHTML = `<div id="hawk-checkout-modal"><div class="hawk-modal-header"><div style="display:flex; align-items:center; gap:10px;"><img src="/static/image/logo.png" alt="Hawk" style="height: 24px; width:auto;"><span id="hawk-modal-title" style="font-weight:600; font-size:16px;"></span></div><button class="hawk-close-btn" onclick="checkoutManager.close()" title="Kapat ve Sıfırla">×</button></div><div id="hawk-step-bar" class="hawk-chk-steps" data-step="1"><span class="hawk-chk-step"><i>1</i>Bilgiler</span><span class="hawk-chk-step"><i>2</i>Özet</span><span class="hawk-chk-step"><i>3</i>Ödeme</span></div><div id="hawk-modal-content" class="hawk-modal-body"></div><div id="hawk-modal-footer" class="hawk-modal-footer"></div></div>`;
        document.body.appendChild(overlay);
    }

    // Yalnızca görsel: hangi adımda olunduğunu gösterir. Sipariş verisine,
    // alan id'lerine ya da gönderim akışına hiçbir etkisi yok.
    markStep(n) {
        const bar = document.getElementById('hawk-step-bar');
        if (bar) bar.setAttribute('data-step', String(n));
    }
}

const checkoutManager = new HawkCheckoutManager({ language: 'tr' });

// Klasik <script> iken üst düzey `const` global sözcüksel bağ oluşturuyordu ve
// hem bu dosyanın ürettiği inline `onclick="checkoutManager..."` hem de
// HawkUIController'daki `typeof checkoutManager !== 'undefined'` kontrolü
// buna güveniyordu. ES modülünde bu bağ modül kapsamında kalır; global'e
// açıkça yazmazsak sipariş penceresi hiç açılmaz.
window.checkoutManager = checkoutManager;